import React from "react";
import { Link } from "react-router-dom";
import LegalPage, { InfoCard } from "@/components/LegalPage";
import { Cookie, Info, Layers, Globe2, SlidersHorizontal, MessageCircle } from "lucide-react";

export default function Cookies() {
  const sections = [
    {
      id: "overview", title: "What Are Cookies?", icon: Info,
      body: (
        <p>
          Cookies (and similar technologies like local storage) are small pieces of data your browser stores on your device.
          They help sites remember you, keep you signed in, and understand how the site is used.
        </p>
      ),
    },
    {
      id: "what-we-set", title: "Cookies We Use", icon: Layers, highlight: "cyan",
      body: (
        <>
          <InfoCard icon={Info} title="🔒 Strictly Necessary">
            <p>Session tokens (<code>sc_token</code>), age-gate confirmation (<code>sc_age_ok</code>). These make the Service function. You cannot disable them and continue using MystiCast.</p>
          </InfoCard>
          <InfoCard icon={SlidersHorizontal} title="🎛 Preferences" tone="cyan">
            <p>Theme, chat layout, muted channels. Set by the app when you change a preference.</p>
          </InfoCard>
          <InfoCard icon={Layers} title="📊 Analytics (aggregate only)" tone="orange">
            <p>How many people visited a page, which games were popular, error diagnostics. Never linked to a name or email in our analytics store.</p>
          </InfoCard>
          <InfoCard icon={Globe2} title="💳 Payments" tone="pink">
            <p>Stripe sets its own cookies to prevent card fraud. See <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noreferrer">Stripe&apos;s cookie policy</a>.</p>
          </InfoCard>
        </>
      ),
    },
    {
      id: "third-party", title: "Third-Party Cookies", icon: Globe2,
      body: (
        <p>
          We integrate with Stripe (payments, identity verification). Stripe may set cookies on the domains where their forms load,
          governed by their own policies. Beyond Stripe we currently set <strong>no third-party marketing or advertising cookies</strong>.
        </p>
      ),
    },
    {
      id: "managing", title: "Managing Cookies", icon: SlidersHorizontal,
      body: (
        <>
          <ul>
            <li>Most browsers let you refuse, clear, or block cookies through Settings → Privacy.</li>
            <li>Blocking strictly-necessary cookies will break sign-in and age verification.</li>
            <li>You can clear MystiCast&apos;s local storage from your browser dev tools; you&apos;ll be signed out and re-asked for age confirmation.</li>
          </ul>
        </>
      ),
    },
    {
      id: "contact", title: "Contact", icon: MessageCircle,
      body: (
        <p>Questions about cookies? See <Link to="/contact">Contact</Link> or read our full <Link to="/privacy">Privacy Policy</Link>.</p>
      ),
    },
  ];

  return (
    <LegalPage
      icon={Cookie}
      label="COOKIE POLICY"
      title="Cookie Policy"
      intro="Learn how cookies improve your MystiCast experience — and how you can control them."
      updated="February 2026"
      sections={sections}
      contact={{
        title: "Cookie questions?",
        body: "Our privacy team is happy to explain what any cookie does and why it's set.",
        cta: { label: "Ask a Question", to: "/contact" },
      }}
    />
  );
}
